// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"f6cfc7a0","905":"71156d94"}[chunkId] + ".chunk.js";
};